namespace('compass.hotel');

compass.require('compass.hotel.RoomTypesWidget');
compass.require('compass.hotel.StayVisualizationWidget');
compass.require('compass.demographic.CreditCardWidget');
compass.require('compass.demographic.PaymentWidget');
compass.requireLib('compass.util.format');
compass.require('compass.util.validate');
compass.require('compass.demographic.FrequentGuestNumberWidget');
compass.require('compass.hotel.RoomRequestsWidget');


compass.hotel.EditReservationWidget = compass.defineWidget(function EditReservationWidget(options) {

	var me = this;
	var $j = jQuery;
	var d = jQuery.dom;
	var _settings = options;

	var _cf = _settings.meetingInfo.defaultCurrencyFormatter;

	var _currentRoomTypeId;
	var _visualizationWidget;
	var _roomTypesWidget;
	var _roomTypeArriveDepartWidget;
	var _paymentWidget;
	var _frequentGuestNumberWidget;
	var _roomRequestsWidget;

	// stay data for bookingGridWidget and roomTypesWidget
	var _requestedRooms = 1;
	var _checkInDate  = _settings.stay.arrive;
	var _checkOutDate = _settings.stay.depart;

	var _validator = new compass.validator({
		widget: me,
		onValid: function (field, opts) {
			field.removeClass("invalid");
		},
		onInvalid: function (field, opts) {
			field.addClass("invalid");
		}
	});

	var _str2date = function (src) {
		src = src.split("-");
		return new Date(parseInt(src[0], 10), parseInt(src[1], 10),
				parseInt(src[2], 10), 0, 0, 0, 0);
	};

	var _getNightArrayForCurrentRoomType = function(){
		_currentRoomTypeId = _settings.stay.blockedRoomId;
		var currentRoomTypeIndex = _getRoomTypeIndex(_currentRoomTypeId);
		var nightsForRoomType = _settings.roomTypes[currentRoomTypeIndex].nights;
		return _settings.roomTypes[currentRoomTypeIndex].nights;
	};

	this.render = function(widgetElem) {
		_currentRoomTypeId = _settings.stay.blockedRoomId;
		var currentRoomTypeIndex = _getRoomTypeIndex(_currentRoomTypeId);

		/*loop through the nights and make sure that the nights that they already have booked are marked as available */
		var nightsForRoomType = _settings.roomTypes[currentRoomTypeIndex].nights;
		var currentNights = _.filter(nightsForRoomType, function(n) {
			return n.date >= _settings.stay.arrive && n.date < _settings.stay.depart;
		});
		_.each(currentNights, function(n) {
			n.availInfo = 'AVAIL';
		});

		var visualizationHolder = d.div({ className : 'stayVisualizationHolder'});
		_visualizationWidget = new compass.hotel.StayVisualizationWidget(visualizationHolder, {
			nights : _.filter(nightsForRoomType, function(n) {
				return n.date >= _settings.stay.arrive && n.date <= _settings.stay.depart;
			}),
			roomType : {'roomTypeName': _settings.roomTypes[currentRoomTypeIndex].name},
			currencyCode : _settings.meetingInfo.currencyCode,
			meetingInfo : _settings.meetingInfo
		});

		var roomTypesHolder = d.div();
		var roomTypeArriveDepartHolder = d.div({ className : 'roomTypeArriveDepartHolder'});

		// translate data
		_.map(_settings.roomTypes, function(roomType) {
			roomType.blocked_room_id = roomType.blockedRoomId;
			return roomType;
		});

		_roomTypeArriveDepartWidget = new compass.group.RoomTypeArriveDepartWidget(roomTypeArriveDepartHolder, {
			meetingInfo : _settings.meetingInfo,
			roomTypes: _settings.roomTypes,
			availabilityInfoBasedOnCheckin : $j.extend(true, [], _settings.roomTypes),
			nights: nightsForRoomType,
			selectedArrive: _settings.stay.arrive,
			selectedDepart: _settings.stay.depart,
			selectedBlocked_room_id: _settings.stay.blockedRoomId,
			requestedRooms: _requestedRooms,
			editable: _settings.canEditRoom
		});

		var cardHasBeenCharged = _settings.individualChargeInfo ? _settings.individualChargeInfo.has_been_charged : false;


		var paymentHolder = d.div({ className : 'paymentHolder'});
		_paymentWidget = new compass.demographic.PaymentWidget(paymentHolder, {
			meetingInfo : _settings.meetingInfo,
			addressWidget : {countries : _settings.countriesAndStates.countries, states : _settings.countriesAndStates.states, countries_with_states : _settings.countriesAndStates.countries_with_states},
			storedPayments : _settings.storedCards,
			currentPayment: _settings.payment,
			creditCardTypes : _settings.payment.options,
			validator: (cardHasBeenCharged || !_settings.payment.hasPermission) ? null : _validator,
			minExpiration: _str2date(_settings.stay.depart),
			maskCCNumber : _settings.maskCCNumber,
			displayCVC : _settings.payment.store_CVC,
			cardWillBeCharged: _settings.blockChargeInfo ? _settings.blockChargeInfo.has_charging : false,
			cardHasBeenCharged: cardHasBeenCharged,
			cardHasDeposit: _settings.individualChargeInfo ? _settings.individualChargeInfo.has_deposit : false,
			cardHasServiceFees: _settings.individualChargeInfo ? _settings.individualChargeInfo.has_service_fees : false,
			payMethods: _settings.payment.options,
			displayBillingNotes: _settings.payment.displayBillingNotes,
			billingNotes: _settings.payment.billingNotes,
			displayEarnedComps: _settings.payment.displayEarnedComps,
			availableEarnedComps: _settings.payment.availableEarnedComps,
			arriveDate: _checkInDate,
			departDate: _checkOutDate,
			earnedCompsUsed: _settings.payment.earnedCompsUsed,
		});

		me.bind("EditReservationDatesWidget.earnedCompsChange", function(event, eventData) {
			_paymentWidget.processStayChange(eventData.arrive, eventData.depart);
		});

		var frequentGuestNumberHolder = d.div({ 
			id: 'frequentGuestNumber',
			className: 'frequentGuestNumberHolder'
		});
		_frequentGuestNumberWidget = new compass.demographic.FrequentGuestNumberWidget(frequentGuestNumberHolder, {
			WUID : 'frequentGuestNumber_editReservationWidget',
			frequentGuestNumber : _settings.frequentGuestNumber,
			validator : _validator
		});

		var frequentGuestNumberUpdated;
		_frequentGuestNumberWidget.bind("FrequentGuestNumberWidget.guestNumberChanged", function (event) {
			frequentGuestNumberUpdated = _frequentGuestNumberWidget.grabValues();
		});

		var roomRequestsHolder = d.div({ 
			id: 'roomRequests',
			className: 'roomRequestsHolder'
		});
		_roomRequestsWidget = new compass.hotel.RoomRequestsWidget(roomRequestsHolder, {
			WUID : 'roomRequestsWidget_editReservationWidget',
			collapsable : false,
			roomRequestOptions : _settings.requestsInfo.requests,
			accessibilityOptions : _settings.requestsInfo.accessibility,
			showExtraNotes : _settings.requestsInfo.showExtraNotes,
			showADAOptions : _settings.requestsInfo.showADAOptions,
			notes : _settings.requestsInfo.notes
		});

	function _triggerStayUpdate() {
		var data = {
			housingId: _settings.stay.housingId,
			roomRequests: {}
		};

		if (_settings.canEditRoom) {
			var rdh = compass.util.restrictedDateHelper();
			var noArriveDatesArray = rdh.restrictedDates(_getNightArrayForCurrentRoomType(), true);
			var noDepartDatesArray = rdh.restrictedDates(_getNightArrayForCurrentRoomType(), false);
			var roomTypeData = _roomTypeArriveDepartWidget.grabValues();
			var violatedRestrictedDates = rdh.violatedRestrictedDates(
				[{"arrive" : roomTypeData.arrive, "depart" : roomTypeData.depart}],
				noArriveDatesArray, 
				noDepartDatesArray
			);
			var dateRestrictionErrorMessages = rdh.createDateRestrictionErrors(violatedRestrictedDates);
			var roomTypeErrorMessage = _roomTypeArriveDepartWidget.datesValidationMessage();

			if (!roomTypeErrorMessage.length) {
				
				widgetArray = [_paymentWidget];

				// let's detach any hints that are attached to currently invalid fields
				var vh = compass.util.validationHelper(_validator);
				vh.detachHints();
				
				var errorsExist = vh.attachHints();
				if(errorsExist){
					return;
				}

				if(dateRestrictionErrorMessages.length){
					rdh.displayMultiErrorAlert(dateRestrictionErrorMessages);
					return;
				}
				
				data.roomTypeId = _roomTypeArriveDepartWidget.roomTypeGrabValues().blocked_room_id;
				data.stay = _roomTypeArriveDepartWidget.datesGrabValues();
				data.roomRequests = _roomRequestsWidget.grabValues();
			} else {
				d.alert(roomTypeErrorMessage);
				return;
			}
		} else {
			// let's detach any hints that are attached to currently invalid fields
			var vh = compass.util.validationHelper(_validator);
			vh.detachHints();
			
			var errorsExist = vh.attachHints();
			if(errorsExist){
				return;
			}

		}

		var cardHasBeenCharged = _settings.individualChargeInfo ? _settings.individualChargeInfo.has_been_charged : false;
		var paymentEditable = _settings.payment.hasPermission || _settings.payment.canEditExternally;
		var hasDeposit = _settings.individualChargeInfo && _settings.individualChargeInfo.has_deposit;
		var includePaymentInfo = (paymentEditable && !(cardHasBeenCharged && hasDeposit));
		if (includePaymentInfo) {
			data.payment = _paymentWidget.grabValues();
		}
		
		// grab updated hotel rewards number if changed or added
		if (frequentGuestNumberUpdated && frequentGuestNumberUpdated !== _settings.frequentGuestNumber) {
			data.frequentGuestNumber = _frequentGuestNumberWidget.grabValues();
		}

		compass.loading.start($j('.updateStay').empty(), { color : '#FFFFFF' });
		me.trigger('EditReservationWidget.update', data);
		return false;
	}

	var cancelRoomsDialogId = compass.generateId();
	function _triggerCancel() {
		me.trigger('EditReservationWidget.cancel', {dialogId: cancelRoomsDialogId});
		return false;
	}

	var additionalChargesText;
	if (_settings.blockChargeInfo && _settings.blockChargeInfo.has_charging) {
		additionalChargesText = d.div({ className: 'additionalCharges' }, 'Room type or date changes may incur additional deposit charges.');
	} else {
		additionalChargesText = '';
	}

	widgetElem.append(
		d.div({ className : 'editHeader' },
			d.h3({ className : 'headerTitle' }, 'Modify Your Reservation'),
			d.div({ className : 'hotelName' }, _getHotelName(_settings))
		),
		d.div({ className : 'currentReservationHeader' }, 'Current Reservation'),
		visualizationHolder,
		additionalChargesText,
		roomTypeArriveDepartHolder,
		paymentHolder,
		frequentGuestNumberHolder,
		roomRequestsHolder,
		d.div({ className : 'controlButtons' },
			d.button({
				className : 'updateStay button',
				role : 'button',
				'ARIA-role' : 'button',
				tabindex : 0
			}, 'Update').activate(_triggerStayUpdate),
			d.div({ className : 'cancelStay' },
				d.a({'aria-owns': cancelRoomsDialogId, href : '#' }, 'Cancel Rooms <abbr alt="">&raquo;</abbr>').activate(_triggerCancel)
				),
			d.div({ className : 'clear' })
			)
		);
	};

	function _getRoomTypeIndex(roomTypeId) {
		return currentRoomTypeIndex = _.indexOf(
				_.pluck(_settings.roomTypes, 'blockedRoomId'),
				roomTypeId);
	}

	function _getHotelName(settings) {
		return settings.hotelName;
	}

}, {
	WUID : 'defaultEditReservationWUID',
	widgetName : 'EditReservationWidget',
	currentRoomTypeId : 0,
	meetingInfo : { },
	roomTypes : [ ],
	payment : { },
	countriesAndStates : {},
	hotelName : '',
	maskCCNumber : false,
	blockChargeInfo: undefined,
	individualChargeInfo: undefined,
	canEditRoom: true,
	frequentGuestNumber: '',
	requestsInfo: { }
});

